import 'angular';
import '../../../../../lib/assets/javascripts/devex/util';
import 'angular-sanitize';
import template from './report_description.template.html?raw';

const moduleDependencies = ['ngSanitize'];

const controller = function() {
  const that = this;
  /**
   * Checks if the property exists with a valid value (not empty string,
   * not 0 number, not empty array, not empty object, not null, not undefined)
   * on the report
   *
   * @param {string} property - Property to be checked
   * @returns {boolean} true if the property exists on the report with a valid
   *                    value, false if not
   */
  that.reportContainsValid = property => devex.util.containsProp(that.report, property);
};

angular
  .module('fundingSearchApp.directives.reportDescription', moduleDependencies)
  .run(['$templateCache', function($templateCache) {
    $templateCache.put(template, template);
  }])
  .directive('reportDescription', () => ({
    restrict: 'E',
    templateUrl: template,
    scope: {
      report: '='
    },
    bindToController: true,
    controller,
    controllerAs: 'vm'
  }));
